exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NavFindProducts .ant-btn.styled-button-wrapper--button a:hover {\n  text-decoration: none;\n}\n.NavFindProducts .nav-section__select-wrapper.ant-select {\n  width: calc(50% - 1rem);\n}\n.NavFindProducts .nav-section__search {\n  display: inline-block;\n  width: calc(50% - 0.5rem);\n  text-align: right;\n}\n", ""]);

